<template>
  <div>
     <div
        v-if="loader"
        style="
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        padding-top: 25%;
        background-color: rgba(255, 255, 255, 0.31);
      "
    >
      <div class="text-xs-center">
        <v-progress-circular
            :size="70"
            :width="7"
            indeterminate
            color="#ff9233"
            class="text-xs-center my-5"
            large
        ></v-progress-circular>
      </div>
    </div>
    <v-container fluid grid-list-md class="padding_10">
      <v-layout class="index_header table_opacity_8">
        <!-- <v-flex xs12 md6 class="ml-0" justify-space-around>
          <v-autocomplete
            v-model="filters.station"
            :items="local_stations"
            prepend-icon="mdi-database-search"
            placeholder="Search By Station Name"
            :search-input.sync="search_title"
            item-value="id"
            item-text="name"
            clearable
            @change="searchByTitle()"
          ></v-autocomplete>
        </v-flex> -->
        <v-flex xs12 class="text-xs-right" mt-3>
          <v-menu offset-y>
            <v-btn
              slot="activator"
              color="rgb(248 71 6)"
              class="white--text add_notification"
            >
              <router-link to="/create-railway-penalty" class="white--text">
                <v-icon color="#bbbbc6" class="white--text mr-2">edit</v-icon
                >Create Railway Penalty</router-link>
            </v-btn>
          </v-menu>
        </v-flex>

      </v-layout>

        <v-dialog
          v-model="delete_model"
          scrollable
          :overlay="false"
          max-width="500px"
          transition="dialog-transition"
          persistent
      >
        <v-card>
          <v-form>
            <v-card-text>
              <v-layout row wrap>
                <v-flex xs12 md12 lg12>
                  <h3>Are you sure you want to delete the Railway Penalty Detail?</h3>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" @click="confirmDelete">Delete</v-btn>
              <v-btn
                  small
                  color="black"
                  flat
                  type="reset"
                  @click="delete_model = !delete_model"
              >Cancel</v-btn
              >
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

       <v-dialog
          v-model="edit_dialog"
          scrollable
          :overlay="false"
          max-width="500px"
          max-height="800px"
          transition="dialog-transition"
      >
        <v-card>
          <v-form
              @submit.prevent="validateBeforeSubmit('updateRailwayPenaltyDetails')"
              data-vv-scope="updateRailwayPenaltyDetails"
              ref="form"
              v-model="valid"
          >
            <v-card-text>
              <v-card-title primary-title>
                <span class="headline"></span>
              </v-card-title>
              <v-container fluid grid-list-md style="padding: 0 16px 16px 16px">
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                        name="title"
                        label="Title"
                        v-model="railway_penalty_object.title"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        name="description"
                        label="Description"
                        v-model="railway_penalty_object.description"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs12>
                    <v-text-field
                        name="penalty"
                        label="Penalty"
                        v-model="railway_penalty_object.penalty"
                    ></v-text-field>
                  </v-flex>
                   <v-flex xs12>
                    <v-text-field
                        name="ref_link"
                        label="Ref Link"
                        v-model="railway_penalty_object.ref_links"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                        name="section_no"
                        label="Section No"
                        v-model="railway_penalty_object.section_no"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small color="primary" type="submit">Submit</v-btn>
              <v-btn small flat @click="edit_dialog = !edit_dialog">Cancel</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>

      <v-data-table
        no-results-text="Loading... Please wait"
        :headers="headers"
        :items="railway_penalty_list"
        :pagination.sync="pagination"
        :loading="loaders.railway_penalty_list_loader"
        :total-items="total_items"
        :rows-per-page-items="[10, 20, 50, 100]"
      >
        <template v-slot:headers="props">
          <tr>
            <th
              style="width: 27%"
              v-for="header in props.headers"
              :key="header.text"
            >
              {{ header.text }}
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          
            
          <td>{{ props.item.title }}</td>
          <td>{{ props.item.description }}</td>
          <td>{{ props.item.penalty}}</td>
          
          <td>{{ props.item.ref_links}}</td>
           <td>{{ props.item.section_no}}</td>
          <td>{{ props.item.updated_at}}</td>
          <td class='pa-1'>
             <v-layout row>
                <v-btn small color="primary" class="white--text elevation-5" @click="penaltyDetails(props.item)">Edit</v-btn>
                <v-btn small color="#F84706" class="white--text elevation-5" @click="penaltyDelete(props.item.id)">Delete</v-btn>
            </v-layout>
          </td>
        
        </template>
        <template slot="no-data">
          <v-layout
            row
            wrap
            justify-center
            class="text-xs-center"
            v-if="loaders.railway_penalty_list_loader"
          >
            Loading... Please wait
          </v-layout>
          <v-layout row wrap justify-center class="text-xs-center" v-else>
            No data available
          </v-layout>
        </template>
      </v-data-table>
       <v-snackbar
          :color="snack_bar.color"
          :top="snack_bar.top"
          :bottom="snack_bar.bottom"
          :left="snack_bar.left"
          :right="snack_bar.right"
          v-model="snack_bar.show"
      >
        {{ snack_bar.message }}
        <v-btn dark flat @click.native="snack_bar.show = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "Index",
  data: () => {
    return {
      headers: [
        {
          text: "Title",
          value: "title",
          align: "left",
          sortable: false,
        },
        {
          text: "Description",
          value: "description",
          sortable: false,
        },
        {
          text: "Penalty",
          value: "penalty",
          sortable: false,
        },
        {
          text: "Ref Links",
          value: "ref_links",
          sortable: false,
        },
         {
          text: "Section No",
          value: "section_no",
          sortable: false,
        },
         {
          text: "Updated_at",
          value: "updated_at",
          sortable: false,
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
        },
      ],
      Ecart_list:[],
      contact_list:[],
      railway_penalty_list:[],
      ecart_details_object:{},
      contact_details_object:{},
      railway_penalty_object:{},
      contact_category:[],
      loaders: {
        railway_penalty_list_loader: false,
      },
      station_ads_inventory_list: [],
      station_inventory_object:{},
      local_stations:[],
      api_type:"web",
      loader: false,
      total_items: 0,
      status: true,
      valid:false,
      edit_dialog:false,
      delete_model:false,
        read:true,
        snack_bar: {
        show: false,
        message: "",
        top: true,
        right: true,
        bottom: false,
        left: false,
        color: "",
      },  
      titles: [],
      title_type: [],
      title_list: [],
      title_searched: "",
      search_title: "",
      pagination: { sortBy: "created_at", descending: false, rowsPerPage: 10 },
      filters: {
        station:"",
        title: "",
        Published: false,
        Draft: false,
      },
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      },
    },
   
    "filters.station": {
      handler(value) {
        if (value == undefined) {
          this.filters.station = "";
          this.getList();
        }
      },
    },
   
   
  },
 methods: {


     penaltyDelete: function(penalty_id) {
        this.railway_penalty_object.penalty_id = penalty_id;
        this.delete_model = true;

     },

   
     confirmDelete: function () {
      this.loader = true;
      axios
          .post(
              `${process.env.VUE_APP_API_URL}/api/v1/delete-railway-penalty`,
              { penalty_id: this.railway_penalty_object.penalty_id},
              { headers: this.$headers }
          )
          .then((response) => {
            if (response.data.status == 1) {
              this.loader = false;
              this.delete_model = false;
              this.snack_bar.message = response.data.message;
              this.snack_bar.show = true;
              this.getList();
            }
          })
          .catch((error) => {})
          .finally(() => {});
    },

      validateBeforeSubmit: function (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this[scope]();
        }
      });
    },

     penaltyDetails: function(penaltyDetail){
      this.railway_penalty_object = penaltyDetail;
      this.edit_dialog=true;
     },

     updateRailwayPenaltyDetails: function(){
     this.loader =  true; 
     let new_railway_penalty_details = Object.assign({}, this.railway_penalty_object);
     
      axios.post(`${process.env.VUE_APP_API_URL}/api/v1/update-railway-penalty`, new_railway_penalty_details,{ headers: this.$headers }).then((response)=>{
        if(response.data.status == 1)
        {

          this.edit_dialog=false;
          this.loader=false;
          this.snack_bar.message = response.data.message;
          this.snack_bar.show = true;
          this.getList();
          // this.$router.push({name:"StationAdsInventoryList"});  
        }
        else
        {
          this.snack_bar.message = response.data.message;
          this.snack_bar.show = true;
        }

      }).catch((error)=>{
        console.log(error);
      }).finally(()=>{
        this.loader =  false;
      });  
     },

    getStations: function(){

       axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/local-station`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
              
                this.local_stations = response.data.stations;
                   
             }  
        })
    },

    filter(e) {
      this.filters.Published = false;
      this.filters.Draft = e;

      this.getList();
    },
    filterPublished(e) {
      this.filters.Draft = false;
      this.filters.Published = e;
      this.getList();
    },
    searchByTitle() {
      this.getList();
    },
    getList: function () {
      this.loaders.railway_penalty_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
        .get(`${process.env.VUE_APP_API_URL}/api/v1/railway-penalties`, {
          headers: this.$headers,
          params: {'params':this.pagination},
        })
        .then((response) => {
          if (response.data.status == 1) {

            this.railway_penalty_list = response.data.penalties;            
            
          }
        })
        .catch((error) => {
          console.log(error);
          this.snack_bar.message = "Error Occured";
          this.snack_bar.show;
        })
        .finally(() => {
          {
            this.loaders.railway_penalty_list_loader = false;
          }
        });
      this.is_loading = false;
    },
    getTitlesList: function (newVal) {
      this.loaders.contact_list_loader = true;
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/api/v1/notification-filter-title`,
          { headers: this.$headers, params: { searched_title: newVal } }
        )
        .then((response) => {
          if (response.data.status == 1) {
            this.title_list = response.data.titles;
          }
        })
        .catch((error) => {
          console.log(error);
          this.snack_bar.message = "Error Occured";
          this.snack_bar.show;
        })
        .finally(() => {
          {
            this.loaders.contact_list_loader = false;
          }
        });
      this.is_loading = false;
    },
     getContactCategory: function(){

       axios
            .get(`${process.env.VUE_APP_API_URL}/api/v1/emergency-contact-category`,{headers:this.$headers})
            .then(response => {
              if (response.data.status == 1)
              { 
                this.contact_category = response.data.contact_category;
             }  
        })
    },
  },
  mounted() {
    this.getList();
    this.getStations();
    this.getContactCategory();
  },
};
</script>

<style>
.add_notification {
  background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%);
}

</style>

